import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import RBButton from '../../../../controls/RBButton'
import CollapsibleSection from '../../../../controls/CollapsibleSection'
import { localize } from '../../../../util/Localizer'
import DoughnutChart from '../../../../controls/DoughnutChart'
import TitledLabel from '../../../../controls/TitledLabel'
import Columns from '../../../../styles/columns'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

class DollarMaxContent extends Component {
  constructor () {
    super()
    this.chart = React.createRef()
  }
  render () {
    const props = this.props
    let data = props.content.data
    let balance = data.availableAmount
    let chartValues = [balance.toFixed(2), data.spentAmount.toFixed(2)]
    let chartLabels = [localize('pages.benefitDetails.dollarMax.available'), localize('pages.benefitDetails.dollarMax.spent')]
    const { classes } = this.props
    return (
      <div>
        <Row top='md' className={classnames(classes.maxContainer)}>
          <Col xs={12} sm={4} md={4} lg={7} className={classnames(classes.maxColumn)}>
            <Row>
              <Col {...Columns.max3}>
                <TitledLabel title='pages.benefitDetails.dollarMax.maxAmount' value={data.maximumAmount} format='currency' />
              </Col>
              <Col {...Columns.max3}>
                <TitledLabel title='pages.benefitDetails.dollarMax.balanceAmount' value={balance} format='currency' />
              </Col>
              <Col {...Columns.max3}>
                <TitledLabel title='pages.benefitDetails.common.period' value={[data.startPeriodDate, data.endPeriodDate]} format='dateRange' />
              </Col>
            </Row>
            <Row bottom='xs'>
              <Col xs={12}>
                {this.props.associatedButton}
              </Col>
            </Row>
          </Col>
          <Col xs={12} smOffset={1} sm={6} mdOffset={2} md={5} lgOffset={1} lg={4}>
            <Row center='xs'>
              <DoughnutChart ref={this.chart}
                index={`dollarMax${props.dollarIndex}`}
                defaultChartLabel={chartLabels[0]}
                defaultChartValue={balance}
                chartValues={chartValues}
                chartLabels={chartLabels}
                className='doughnutChart'
                selectedLabelClasses='hidden-xs'
                width={415}
                height={415}
                alt={`${localize('pages.benefitDetails.dollarMax.doughnut.alt1')} ${data.categoryDescription} ${localize('pages.benefitDetails.dollarMax.doughnut.alt2')}. ${localize('pages.benefitDetails.dollarMax.doughnut.alt3')} $${chartValues[0]}. ${localize('pages.benefitDetails.dollarMax.doughnut.alt4')} $${chartValues[1]}.`} />
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

class DollarMax extends Component {
  constructor (props) {
    super(props)
    this.returnClaimsButton = this.returnClaimsButton.bind(this)
    this.showAssociatedClaim = this.showAssociatedClaim.bind(this)
    this.itemId = `dollarMaxItem${props.key}`
    this.state = { expandedKey: false }
    this.dollarMaxContent = React.createRef()
  }

  showAssociatedClaim (e) {
    e.stopPropagation()
    const accumClaimParams = this.props.data.accumClaimParameters
    window.localStorage.removeItem('claimsParams')
    window.localStorage.setItem('claimsParams', JSON.stringify(accumClaimParams))
    this.props.push('/AssociatedClaimLines')
  }

  // TODO ... need to show this button on the left side of the summary page in the header
  returnClaimsButton (classNames) {
    if (!this.props.data.accumClaimParameters) {
      return false
    }
    return <RBButton
      onClick={this.showAssociatedClaim}
      variant='outlined'
      className={classNames}
      label={localize('pages.benefitDetails.dollarMax.btn')} />
  }

  handlePanelExpandedChanged = panelKey => (event, expanded) => {
    this.setState({ expandedKey: expanded ? panelKey : false })
    if (expanded) {
      this.dollarMaxContent.current.chart.current.loadChart()
    } else {
      this.dollarMaxContent.current.chart.current.unloadChart()
    }
  }

  render () {
    const data = this.props.data
    const props = this.props
    return (
      <div className='dollarMax'>
        <CollapsibleSection
          id={this.itemId}
          showMuiBorder={false}
          heading={`${data.categoryDescription}`}
          accessory={this.returnClaimsButton('claimButton hidden-xs hidden-sm visible-md visible-lg')}
          expanded={this.state.expandedKey === this.itemId}
          onExpanded={this.handlePanelExpandedChanged(this.itemId)}>
          <React.Fragment>
            <DollarMaxContent
              content={props}
              ref={this.dollarMaxContent}
              dollarIndex={props.index}
              showAssociatedClaim={this.showAssociatedClaim}
              associatedButton={this.returnClaimsButton('claimButton visible-xs visible-sm hidden-md hidden-lg')}
              classes={this.props.classes} />
          </React.Fragment>
        </CollapsibleSection>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
  }
}
const styles = {
  maxContainer: { display: 'flex', alignItems: 'inherit' },
  maxColumn: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }
}
const ConnectedDollarMax = connect(mapStateToProps, { push })(injectIntl(DollarMax))

export default withStyles(styles)(ConnectedDollarMax)



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/DollarMax.js